<mat-accordion>
  <mat-expansion-panel (closed)="panelOpenState = false" (opened)="panelOpenState = true">
    <mat-expansion-panel-header>
      <mat-panel-title>Dati contabili</mat-panel-title>
      <mat-panel-description>
        Informazioni contabili dettagliate e registrazioni finanziarie.
      </mat-panel-description>
    </mat-expansion-panel-header>
    <app-accounting-practice-form [data]="formData"></app-accounting-practice-form>
  </mat-expansion-panel>
  <mat-expansion-panel (closed)="panelOpenState = false" (opened)="panelOpenState = true">
    <mat-expansion-panel-header>
      <mat-panel-title>Dati fatture di vendita</mat-panel-title>
      <mat-panel-description>Dati dettagliati delle fatture di vendita.</mat-panel-description>
    </mat-expansion-panel-header>
    <div *ngIf="!hasSellerInvoiceData" class="flex flex-col items-center justify-center p-8">
      <div class="bg-slate-700/50 rounded-lg p-6 max-w-md w-full text-center">
        <fa-icon [icon]="faInbox" class="text-4xl text-slate-400 mb-4"></fa-icon>
        <p class="text-slate-300 text-base font-medium">Nessun dato disponibile</p>
        <p class="text-slate-400 text-sm mt-2">
          Non sono presenti fatture di vendita per questa pratica.
        </p>
      </div>
    </div>
    <app-new-table
      *ngIf="hasSellerInvoiceData"
      [dataSource]="dataSourceSellerInvoice"
      [displayedColumns]="displayedColumnsSellerInvoice"
      [hideFilterHeaders]="true"
      [initialSort]="{
        active: 'practiceNumber',
        direction: 'desc'
      }"
      [reloadTrigger$]="reloadTrigger$"
      [showElementsPerPage]="false"
      [showPaginate]="false"
    ></app-new-table>
  </mat-expansion-panel>
  <mat-expansion-panel (closed)="panelOpenState = false" (opened)="panelOpenState = true">
    <mat-expansion-panel-header>
      <mat-panel-title>Dati fatture di acquisto</mat-panel-title>
      <mat-panel-description>Dettagli completi delle fatture di acquisto.</mat-panel-description>
    </mat-expansion-panel-header>
    <div *ngIf="!hasBuyerInvoiceData" class="flex flex-col items-center justify-center p-8">
      <div class="bg-slate-700/50 rounded-lg p-6 max-w-md w-full text-center">
        <fa-icon [icon]="faInbox" class="text-4xl text-slate-400 mb-4"></fa-icon>
        <p class="text-slate-300 text-base font-medium">Nessun dato disponibile</p>
        <p class="text-slate-400 text-sm mt-2">
          Non sono presenti fatture di acquisto per questa pratica.
        </p>
      </div>
    </div>
    <app-new-table
      *ngIf="hasBuyerInvoiceData"
      [dataSource]="dataSourceBuyerInvoice"
      [displayedColumns]="displayedColumnsBuyerInvoice"
      [hideFilterHeaders]="true"
      [initialSort]="{ active: 'practiceNumber', direction: 'desc' }"
      [reloadTrigger$]="reloadTrigger$"
      [showElementsPerPage]="false"
      [showPaginate]="false"
    ></app-new-table>
  </mat-expansion-panel>
  <mat-expansion-panel (closed)="panelOpenState = false" (opened)="panelOpenState = true">
    <mat-expansion-panel-header>
      <mat-panel-title>Dati movimenti cassa</mat-panel-title>
      <mat-panel-description>Controllo movimenti cassa Webapp.</mat-panel-description>
    </mat-expansion-panel-header>
    <div
      *ngIf="dataTableMovimentiCassa.length === 0"
      class="flex flex-col items-center justify-center p-8"
    >
      <div class="bg-slate-700/50 rounded-lg p-6 max-w-md w-full text-center">
        <fa-icon [icon]="faInbox" class="text-4xl text-slate-400 mb-4"></fa-icon>
        <p class="text-slate-300 text-base font-medium">Nessun dato disponibile</p>
        <p class="text-slate-400 text-sm mt-2">
          Non sono presenti movimenti cassa per questa pratica.
        </p>
      </div>
    </div>
    <app-table-group-rows
      *ngIf="dataTableMovimentiCassa.length > 0"
      [columns]="columnsMovimentiCassa"
      [data]="dataTableMovimentiCassa"
      [showSumCounter]="true"
    ></app-table-group-rows>
  </mat-expansion-panel>
  <mat-expansion-panel (closed)="panelOpenState = false" (opened)="panelOpenState = true">
    <mat-expansion-panel-header>
      <mat-panel-title>Movimenti contabili Navision</mat-panel-title>
      <mat-panel-description>
        Quadratura contabile data conto contabile cliente.
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div
      *ngIf="dataTableQuadraturaPractice2.length === 0"
      class="flex flex-col items-center justify-center p-8"
    >
      <div class="bg-slate-700/50 rounded-lg p-6 max-w-md w-full text-center">
        <fa-icon [icon]="faInbox" class="text-4xl text-slate-400 mb-4"></fa-icon>
        <p class="text-slate-300 text-base font-medium">Nessun dato disponibile</p>
        <p class="text-slate-400 text-sm mt-2">
          Non sono presenti movimenti contabili Navision per questa pratica.
        </p>
      </div>
    </div>
    <app-table-group-rows
      *ngIf="dataTableQuadraturaPractice2.length > 0"
      [columns]="columnsQuadraturaPractice"
      [data]="dataTableQuadraturaPractice2"
      [showSumCounter]="true"
    ></app-table-group-rows>
  </mat-expansion-panel>
  <mat-expansion-panel (closed)="panelOpenState = false" (opened)="panelOpenState = true">
    <mat-expansion-panel-header>
      <mat-panel-title>Dati quadratura pratica</mat-panel-title>
      <mat-panel-description>Quadratura contabile chiusura pratica.</mat-panel-description>
    </mat-expansion-panel-header>
    <div
      *ngIf="dataTableQuadraturaPractice.length === 0"
      class="flex flex-col items-center justify-center p-8"
    >
      <div class="bg-slate-700/50 rounded-lg p-6 max-w-md w-full text-center">
        <fa-icon [icon]="faInbox" class="text-4xl text-slate-400 mb-4"></fa-icon>
        <p class="text-slate-300 text-base font-medium">Nessun dato disponibile</p>
        <p class="text-slate-400 text-sm mt-2">
          Non sono presenti dati di quadratura pratica per questa pratica.
        </p>
      </div>
    </div>
    <app-table-group-rows
      *ngIf="dataTableQuadraturaPractice.length > 0"
      [columns]="columnsQuadraturaPractice"
      [data]="dataTableQuadraturaPractice"
      [showSumCounter]="true"
    ></app-table-group-rows>
  </mat-expansion-panel>
</mat-accordion>
